import { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "./journaling.css";
import BeforeFooter from '../components/layout/BeforeFooter';

import journalIcon from '../assets/journal.png';

import JournalGalleryCard from "../components/journaling/JournalGalleryCard";

function Journaling() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section className="journal-hero">
        <div className="journal-hero-text">
          <h1>Loubna's Journal</h1>
          <p>
            Learn how to journal with intention. <br />
            Practical tips, prompts, and reflections to help you write with clarity.
          </p>
        </div>

        <div className="journal-hero-img">
          <img src={journalIcon} alt="journal icon" />
        </div>
      </section>

      {/* ✍️ JOURNAL TYPES */}
      <section className="journal-types">
        
        <h2 className="journal-types-title">Ways to Journal</h2>

        <div className="journal-types-grid">
          <Link to="/journaling/free" className="journal-type-card free" data-aos="fade-up">
            <span className="journal-icon">✍️</span>
            <h3>Free Journaling</h3>
            <p>Write without rules. Let your thoughts flow naturally.</p>
          </Link>

          <Link to="/journaling/prompted" className="journal-type-card prompted" data-aos="fade-up" data-aos-delay="50">
            <span className="journal-icon">🧭</span>
            <h3>Prompted Journaling</h3>
            <p>Guided questions to help you reflect with intention.</p>
          </Link>

          <Link to="/journaling/diary" className="journal-type-card diary" data-aos="fade-up" data-aos-delay="100">
            <span className="journal-icon">📖</span>
            <h3>Diary</h3>
            <p>Capture moments, emotions, and everyday memories.</p>
          </Link>

          <Link to="/journaling/dopamine" className="journal-type-card dopamine" data-aos="fade-up" data-aos-delay="150">
            <span className="journal-icon">⚡</span>
            <h3>Dopamine</h3>
            <p>Short positive entries to boost motivation and mood.</p>
          </Link>

          <Link to="/journaling/planning" className="journal-type-card planning" data-aos="fade-up" data-aos-delay="200">
            <span className="journal-icon">🗂</span>
            <h3>Planning</h3>
            <p>Organize your goals, tasks, and intentions.</p>
          </Link>

          <Link to="/journaling/gratitude" className="journal-type-card gratitude" data-aos="fade-up" data-aos-delay="250">
            <span className="journal-icon">🌸</span>
            <h3>Gratitude</h3>
            <p>Reflect on what you're thankful for, big or small.</p>
          </Link>

          

          <Link to="/journaling/affirmation" className="journal-type-card affirmation" data-aos="fade-up" data-aos-delay="350">
            <span className="journal-icon">✨</span>
            <h3>Affirmation Journal</h3>
            <p>Small reminders of who you are and what you have.</p>
          </Link>

          <Link to="/journaling/unsent-letters" className="journal-type-card unsent-letters" data-aos="fade-up" data-aos-delay="400">
            <span className="journal-icon">💌</span>
            <h3>Unsent Letters</h3>
            <p>Say what you need to say — without ever sending it.</p>
          </Link>

          <JournalGalleryCard />
        </div>
      </section>

      {/* 📚 READ MORE */}
      <section className="journal-articles">
        
        <h2 className="journal-articles-title">Read More</h2>
        <p className="journal-articles-subtitle">
          A few reads to go deeper into the practice of journaling.
        </p>

        <div className="journal-articles-grid">
          <a
            href="https://medium.com/@iamloubna/tips-on-journaling-60436c7cfe83"
            target="_blank"
            rel="noopener noreferrer"
            className="journal-article-card"
            data-aos="fade-up"
          >
            <span className="journal-article-badge">Medium</span>
            <h3>Tips on Journaling</h3>
            <p>
              Tips on Journaling for beginners, from my own experience.
            </p>
            <span className="journal-article-link">Read the article →</span>
          </a>
        </div>
      </section>

      <BeforeFooter />
    </>
  );
}

export default Journaling;